export { default } from "/Users/stephen/dev/thxnothx/tnt-app/app/routes/content/howitworks.tsx";